import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";
import { convertToLocationModel } from "../listLocationModelProvider";
import {
	DocumentItemViewModel,
	ListLocationViewModel,
	RecentDocumentItemViewModel
} from "client/Api/Documents/SharePoint/common";

export function getDownloadFileUrlPath(
	id: number,
	location: ListLocationViewModel
): string {
	const params: string = urlEncodeObject({
		fileId: id,
		location: convertToLocationModel(location)
	});

	return "Documents/SharePoint/FileContent/DownloadFile?" + params;
}

export function getDownloadFileUrl(
	id: number,
	location: ListLocationViewModel
): string {
	return createUrlRelativeToEnvironment(
		getDownloadFileUrlPath(id, location)
	);
}

export function getOpenFileUrl(
	document: DocumentItemViewModel | RecentDocumentItemViewModel
): string {
	const {
		id,
		location
	} = document;

	const params: string = urlEncodeObject({
		fileId: id,
		location: convertToLocationModel(location)
	});

	const url: string = "Documents/SharePoint/FileContent/OpenFile?" + params;

	return createUrlRelativeToEnvironment(url);
}
